import React, { Component } from "react";
import "./ManageInvitations.css";
import Cookie from 'js-cookie';
import {
    Empty, Button, Input, message,
    Table, Icon, Popconfirm, Spin,
    ConfigProvider,
} from 'antd';
import Highlighter from 'react-highlight-words';
import { Link } from "react-router-dom";

// //edit project modal
// let EditForm = Form.create({ name: 'edit_form_in_modal' })(
//     // eslint-disable-next-line
//     class extends Component {
//         render() {

//             const {
//                 visible, onCancel, onCreate, form, eproject //get all the props from Homepage
//             } = this.props;

//             const { getFieldDecorator } = form;
//             return (
//                 <Modal
//                     visible={visible}
//                     title={"Edit invitee permission on project: " + eproject.projectName} //the name is different per modal
//                     okText="Edit"
//                     onCancel={onCancel}
//                     onOk={onCreate}
//                 >
//                     <Form layout="vertical">
//                         <Form.Item label="Permisson">
//                             {getFieldDecorator('invitedPermission', {
//                                 initialValue: eproject.invitedPermission,
//                             })(
//                                 <Checkbox.Group style={{ width: '100%' }}>
//                                     <Row>
//                                         <Col span={8}>
//                                             <Checkbox value="Criteria">Criteria defining</Checkbox>
//                                         </Col>
//                                         <Col span={8}>
//                                             <Checkbox value="Weight">Weighting</Checkbox>
//                                         </Col>
//                                         <Col span={8}>
//                                             <Checkbox value="Evaluation">Evaluation</Checkbox>
//                                         </Col>
//                                     </Row>
//                                 </Checkbox.Group>,
//                             )}
//                         </Form.Item>
//                     </Form>
//                 </Modal>
//             );
//         }
//     }
// );


export default class ManageInvitations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: Cookie.get("email"),

            searchText: '', //for the function of searching project name
            projectlist: [],
            params: {}, //for filter, save the params of changing
            loading: true,
            eproject: {}, //for project to edit

        };
    }

    //function for searching, can be used on different column
    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys, selectedKeys, confirm, clearFilters,
        }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => { this.searchInput = node; }}
                        placeholder={`Search project name`} //${dataIndex}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Search
        </Button>
                    <Button
                        onClick={() => this.handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
        </Button>
                </div>
            ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
            />
        ),
    })
    //for searching function
    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({ searchText: selectedKeys[0] });
    }

      //for reseting the serach
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }
    //change function used for filter
    handleTableChange = (pagination, filters, sorter) => {
        // const pager = { ...this.state.pagination };
        // pager.current = pagination.current;
        // this.setState({
        //   pagination: pager,
        // });
        this.setState({ //save the params of changing, used for manually get projects
            params: {
                sortField: sorter.field,
                sortOrder: sorter.order,
                ...filters,
            }
        })
        this.getInvitedProjects({ //if something changed, get the project again
            // results: pagination.pageSize,
            // page: pagination.current,
            sortField: sorter.field,
            sortOrder: sorter.order,
            ...filters,
        });
    }

    //show or cancel edit modal
    showEditModal = () => {
        this.setState({ editVisible: true });
    }

    handleEditCancel = () => {
        this.setState({ editVisible: false });
    }
    //edit project
    handleEdit = () => {
        const form = this.EformRef.props.form; //get data from modal
        form.validateFields((err, values) => { //can get values based on name
            if (values.invitedPermission=== this.EformRef.props.eproject.invitedPermission) { //no change
                this.setState({ editVisible: false }); //make modal invisible
                form.resetFields(); //reset the form
            }
            else {
                fetch('/project/editInvitedProjectPermission', { //REST edit project
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.EformRef.props.eproject._id, //get the id of project
                        email: this.state.email,
                        eproject: this.EformRef.props.eproject, 
                        invitedPermission: values.invitedPermission
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            this.getInvitedProjects(); //refresh project list
                            this.handleEditCancel(); //make modal invisible
                            message.success(json.message); //edit successful, show message
                            form.resetFields();

                        }
                        else {
                            message.error(json.message); //edit unsuccessful, show alert
                        }
                    });
                // console.log('Received values of form: ', values);
            }
        });
    }
    removeInvitee(record) { //removre invitee
        fetch('/project/removeInvitee', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                record: record,
                email: Cookie.get("email"),
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getInvitedProjects()
                    message.success(json.message); //create successfully, show mesage
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }
    checkInviteeInfo=()=>{

        fetch(`/project/checkInvitees`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getInvitedProjects() //after render immediately get project list
                }
                else{
                    message.error(json.message);
                }
               
            });


    }

    getInvitedProjects = (params = {}) => { //get the project list
        let p = params
        //check if there is params saved
        if (Object.getOwnPropertyNames(params).length === 0) { //this situation happens when create new project and edit project, which can mannually check the change
            p = this.state.params //after creating or editing one project, component mounted but the filter data is cleared, so we read the params last time saved
        }
        fetch(`/project/getInvitees`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: this.state.email,
                params: p //these params are used for filter function
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.setState({ //set state
                        projectlist: json.projectlist.reverse(), //reverse the list to make it show in time order
                        loading: false //to disable the loading status
                    });
                }
            });

    }


    renderProjects() {
        const columns = [{ //the column title of the table
            title: 'Project Name', //the title of column
            dataIndex: 'projectName', //the data index can be used for searching, filtering
            key: 'projectName',
            ...this.getColumnSearchProps('projectName'), //make it can be search
            // render: (text, record) => <Link to={`/alternative/${record.invitedId}`}>{text}</Link>, //make it clickable to the project
            width: '20%',
        }, {
            title: 'Actor Group',
            dataIndex: 'actorGroupName',
            key: 'actorGroupName',
            width: '20%',
        }, {
            title: 'Invitee',
            key: 'invitee',
            dataIndex: 'invitee',
            width: '20%',
        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            render: (text, record) => (
                <span>
                    <Popconfirm title="Are you sure you want to remove this invitee?" onConfirm={() => { this.removeInvitee(record) }} okText="Yes" cancelText="No">
                        <Link to="#">Remove</Link>
                    </Popconfirm>
                </span>
            ),
        }];

        return (
            <div>
                <Table columns={columns}
                    rowKey={record => record.projectid + record.projectActorid + record.invitee} //unique key needed, so we use mongodb id
                    dataSource={this.state.projectlist} //the data source is what we get after component mount
                    onChange={this.handleTableChange} />
            </div>
        );
    }
    //save all the form data of edit
    saveEFormRef = (formRef) => {
        this.EformRef = formRef;
    }

    componentDidMount() {
        try {
            this.checkInviteeInfo()           
        } catch (e) {
            alert(e);
        }
      
    }

    render() {
        return (
            <div className="ManageInvitations" >
                {/* check if there is project */}
                <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                    <ConfigProvider renderEmpty={() => {
                        return (<Empty />
                        );
                    }}>
                        {this.renderProjects()}
                    </ConfigProvider>
                </Spin>
                {/* <EditForm
                    wrappedComponentRef={this.saveEFormRef}
                    visible={this.state.editVisible}
                    onCancel={this.handleEditCancel}
                    onCreate={this.handleEdit}
                    eproject={this.state.eproject} //send the edited project info to the modal
                    projectTags={this.state.projectTags} //send the tag list to the modal
                /> */}
            </div>
        );
    }
}